module.exports = __webpack_public_path__ + "img/files_from_usr_local_go.7ab63d8b.png";